// extracted by mini-css-extract-plugin
export default {"wrapper":"ipaf-popup-banner_wrapper__kKwiy","banner-wrapper":"ipaf-popup-banner_banner-wrapper__HrlEF","close-icon":"ipaf-popup-banner_close-icon__NG0RW"};